import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import { chooseLanguage_en, shell_en, example_en, home_en, my_account_en, products_en, financial_en, wallet_en, notifications_en, } from "./en";
import { chooseLanguage_pt_br, shell_pt_br, example_pt_br, home_pt_br, my_account_pt_br, products_pt_br, financial_pt_br, wallet_pt_br, notifications_pt_br, } from "./pt-br";
export var resources = {
    en: {
        translation: {
            example: example_en,
            financial: financial_en,
            wallet: wallet_en,
        },
        "choose-language": chooseLanguage_en,
        shell: shell_en,
        notifications: notifications_en,
        "my-account": my_account_en,
        home: home_en,
        products: products_en,
    },
    pt: {
        translation: {
            example: example_pt_br,
            financial: financial_pt_br,
            wallet: wallet_pt_br,
        },
        "choose-language": chooseLanguage_pt_br,
        shell: shell_pt_br,
        notifications: notifications_pt_br,
        "my-account": my_account_pt_br,
        home: home_pt_br,
        products: products_pt_br,
    },
};
export var namespaces = [
    "translation",
    "home",
    "products",
    "my-account",
    "notifications",
    "choose-language",
    "shell",
];
i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options.init({
    .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    ns: namespaces,
    // lng: "en", // if you're using a language detector, do not define the lng option
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: resources,
});
export default i18n;
